import { render, staticRenderFns } from "./TermsofService.vue?vue&type=template&id=41dab5b4&scoped=true&"
import script from "./TermsofService.vue?vue&type=script&lang=js&"
export * from "./TermsofService.vue?vue&type=script&lang=js&"
import style0 from "./TermsofService.vue?vue&type=style&index=0&id=41dab5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dab5b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
